export const siteSlice = (set, get) => ({
    isSidebarOpen: true,
    clinicId: null, // Or you can keep it as 1 if you prefer
    user: {},
    selectedUser: {},
    toggleSidebar: () => set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),
    setClinicId: (newclinicId) => set((state) => ({ clinicId: newclinicId })),
    setUser: (newUser) => set((state) => ({
        user: newUser,
        clinicId: newUser.clinicId // Set clinicId directly from user data
    })),
    setSelectedUser: (newSelectedUser) => set((state) => ({ selectedUser: newSelectedUser }))
})